import React from 'react';
import './PrizesSection.css';

const PrizesSection = () => {
  const prizes = [
    {
      position: 'Champion',
      amount: 'PKR 35,000',
      icon: '🏆',
      description: 'Tournament Winner'
    },
    {
      position: 'Runner-Up',
      amount: 'PKR 15,000',
      icon: '🥈',
      description: 'Finalist'
    },
    {
      position: '147 Break',
      amount: 'PKR 25,000',
      icon: '🎯',
      description: 'Maximum Break Prize'
    },
    {
      position: 'Highest Break',
      amount: 'PKR 3,000',
      icon: '💥',
      description: 'Best Break of Tournament'
    },
    {
      position: 'Per Century',
      amount: 'PKR 3,000',
      icon: '💯',
      description: 'For Each Century Break'
    }
  ];

  return (
    <section className="prizes-section">
      <h2 className="prizes-title">Prize Pool</h2>
      <div className="prizes-grid">
        {prizes.map((prize, index) => (
          <div key={index} className="prize-card" style={{ animationDelay: `${index * 0.1}s` }}>
            <div className="prize-icon">{prize.icon}</div>
            <h3 className="prize-position">{prize.position}</h3>
            <div className="prize-amount">{prize.amount}</div>
            <p className="prize-description">{prize.description}</p>
          </div>
        ))}
      </div>
      <div className="total-prize">
        <span className="total-label">Total Prize Pool:</span>
        <span className="total-amount">PKR 81,000+</span>
        <p className="total-note">*Plus additional prizes for century breaks</p>
      </div>
    </section>
  );
};

export default PrizesSection;
